/**
 * Mobile Navigation
 * =================
 * Handles the mobile menu toggle with animated hamburger icon
 * and slide-in navigation from right to left.
 */

(function () {
	'use strict';

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	function init() {
		const menuToggle = document.querySelector('.menu-toggle');
		const navigation = document.querySelector('.main-navigation');
		const headerMain = document.querySelector('.site-header__main');
		const body = document.body;

		// Exit if elements don't exist
		if (!menuToggle || !navigation) {
			return;
		}

		// Create and insert overlay
		const overlay = createOverlay();
		body.appendChild(overlay);

		// Toggle menu on button click
		menuToggle.addEventListener('click', function () {
			toggleMenu();
		});

		// Close menu when clicking overlay
		overlay.addEventListener('click', function () {
			closeMenu();
		});

		// Close menu when clicking menu item
		const menuItems = navigation.querySelectorAll('.menu-item a');
		menuItems.forEach(function (item) {
			item.addEventListener('click', function (e) {
				const parent = item.parentElement;
				const hasChildren =
					parent.classList.contains('menu-item-has-children') &&
					parent.querySelector(':scope > .sub-menu');

				// On mobile: first tap on a parent opens its submenu,
				// second tap follows the link.
				if (hasChildren && window.innerWidth < 1320 && !parent.classList.contains('is-open')) {
					e.preventDefault();
					parent.classList.add('is-open');
					return;
				}
				closeMenu();
			});
		});

		// Close menu on ESC key
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && isMenuOpen()) {
				closeMenu();
				menuToggle.focus();
			}
		});

		// Handle window resize - close menu on desktop
		// Keep in sync with the CSS breakpoint: mobile nav is active
		// below the xl breakpoint (bp-down(lg) → < 1320px) in _header.scss.
		let resizeTimer;
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				if (window.innerWidth >= 1320 && isMenuOpen()) {
					closeMenu();
				}
			}, 250);
		});

		/**
		 * Create overlay element
		 */
		function createOverlay() {
			const overlay = document.createElement('div');
			overlay.className = 'mobile-nav-overlay';
			overlay.setAttribute('aria-hidden', 'true');
			return overlay;
		}

		/**
		 * Toggle menu state
		 */
		function toggleMenu() {
			if (isMenuOpen()) {
				closeMenu();
			} else {
				openMenu();
			}
		}

		/**
		 * Open menu
		 */
		function openMenu() {
			menuToggle.classList.add('is-active');
			navigation.classList.add('is-active');
            headerMain.classList.add('is-active');
			overlay.classList.add('is-active');
			menuToggle.setAttribute('aria-expanded', 'true');
			menuToggle.setAttribute('aria-label', 'Menu sluiten');
			body.style.overflow = 'hidden';

			// Trap focus in navigation
			trapFocus(navigation);
		}

		/**
		 * Close menu
		 */
		function closeMenu() {
			menuToggle.classList.remove('is-active');
			navigation.classList.remove('is-active');
            headerMain.classList.remove('is-active');
			overlay.classList.remove('is-active');
			body.classList.remove('menu-open');
			if (headerMain) {
				headerMain.classList.remove('is-active');
			}
			menuToggle.setAttribute('aria-expanded', 'false');
			menuToggle.setAttribute('aria-label', 'Menu openen');
			body.style.overflow = '';

			// Remove focus trap
			removeFocusTrap();
		}

		/**
		 * Check if menu is open
		 */
		function isMenuOpen() {
			return menuToggle.classList.contains('is-active');
		}

		/**
		 * Trap focus within navigation when open
		 */
		function trapFocus(element) {
			const focusableElements = element.querySelectorAll(
				'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
			);

			if (focusableElements.length === 0) {
				return;
			}

			const firstFocusable = focusableElements[0];
			const lastFocusable = focusableElements[focusableElements.length - 1];

			// Add event listener to trap focus
			element.addEventListener('keydown', handleFocusTrap);

			// Store handler for later removal
			element._focusTrapHandler = handleFocusTrap;

			// Focus first element
			firstFocusable.focus();

			function handleFocusTrap(e) {
				if (e.key !== 'Tab') {
					return;
				}

				if (e.shiftKey) {
					// Shift + Tab
					if (document.activeElement === firstFocusable) {
						e.preventDefault();
						lastFocusable.focus();
					}
				} else {
					// Tab
					if (document.activeElement === lastFocusable) {
						e.preventDefault();
						firstFocusable.focus();
					}
				}
			}
		}

		/**
		 * Remove focus trap
		 */
		function removeFocusTrap() {
			if (navigation._focusTrapHandler) {
				navigation.removeEventListener('keydown', navigation._focusTrapHandler);
				delete navigation._focusTrapHandler;
			}
		}
	}
})();
